import { Component, OnInit } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalService} from "../../services/global.service";
import {UsersService} from "../../services/requests/users.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  login = {
    identifiant: '',
    password: ''
  };
  tentativeConnexion = true;
  error = '';
  constructor(private usersService: UsersService,
              private router: Router) { }

  ngOnInit(): void {
    const id = localStorage.getItem('id') !== undefined && localStorage.getItem('id') !== null;
    const token = localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null;
    if (id && token) {
      this.router.navigate(['/ports']);
    }
  }

  connexion(): void {
    this.error = '';
    this.tentativeConnexion = false;
    
    this.usersService.login(this.login).subscribe(response => {
      if (response.status) {
        localStorage.setItem('id', response.data.id);
        localStorage.setItem('isAdmin', response.data.isAdmin);
        localStorage.setItem('isSousAdmin', response.data.isSousAdmin);
        localStorage.setItem('token', response.data.token);
        this.router.navigate(['/ports']);
      } else {
        this.afficherErreur();
      }
    }, () => {
      this.afficherErreur();
    });
  }

  afficherErreur() {
    this.error = 'Identifiant ou mot de passe incorrect';
    this.tentativeConnexion = true;
  }
}
